import styled from "styled-components"
import { readableColor } from "polished"
import breakpoint from "styled-components-breakpoint"

const getSize = (size) => {
  switch (size) {
    case "small":
      return "1rem"
    case "medium":
      return "2rem"
    case "large":
      return "2.5rem"
    case "extralarge":
      return "60px"
    default:
      return "1.5rem"
  }
}

const getColor = (variant, theme, overrideWithBodyStyle) => {
  switch (variant) {
    case "primary":
      return theme.colors.primary
    case "secondary":
      return theme.colors.secondaryAlternative || theme.colors.secondary
    case "content":
      return theme.colors.content.text
    case "profile":
      return !!overrideWithBodyStyle ? theme.colors.body : theme.colors.content.text
    case "secondaryReadable":
      return readableColor(
        theme.colors.secondary,
        theme.colors.buttons.darkColor,
        theme.colors.buttons.lightColor,
        false
      )
    default:
      return theme.colors.body
  }
}

export const Icon = styled.svg`
  height: ${({ size }) => getSize(size)};
  width: ${({ size }) => getSize(size)};
  fill: ${({ variant, theme }) => getColor(variant, theme, true)};
  cursor: pointer;

  ${breakpoint("tablet")`
    fill: ${({ variant, theme, body }) => getColor(variant, theme, body)};
  `}
`

export const Path = styled.path`
  fill: ${({ variant, theme }) => getColor(variant, theme, true)};

  ${breakpoint("tablet")`
    fill: ${({ variant, theme, body }) => getColor(variant, theme, body)};
  `}
`

export const Ellipse = styled.ellipse`
  stroke: ${({ variant, theme }) => getColor(variant, theme, true)};
`
